import { macroCTV } from './ctv';
import { macroGIF } from './gif';
import { macroSacaTuTarjeta } from './saca-tu-tarjeta';

export const MACRO_TEMPLATES = [macroCTV, macroGIF, macroSacaTuTarjeta];

export * from './ctv';
export * from './gif';
export * from './saca-tu-tarjeta';
